import { Component } from '@angular/core';

import { stateService, viewService } from '@unpispas/upp-base';

/** Root shell for the guest QR access app (`Access = 'GUEST'`, `WorkMode = 'QRA'`). */
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent {
    title = 'unpispas-qra';

    constructor(public view: viewService, private state: stateService) {
        this.view.Access = 'GUEST';
        this.state.WorkMode = 'QRA';
    }
}
